module.exports = __webpack_public_path__ + "static/media/blcn.99917027.svg";